import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
// styles
import { CloseButtonStyled } from "./styles";
// components
import CloseIcon from "core/ReusableIcons/Close";
var CloseButton = function (_a) {
    var onClick = _a.onClick, className = _a.className;
    return (_jsx(CloseButtonStyled, { type: "button", onClick: onClick, "aria-label": "Close", className: className, children: _jsx(CloseIcon, { size: { width: "16", height: "16" }, ariaHidden: true }) }));
};
export default CloseButton;
